'use client';

import {
  ControllerRenderProps,
  FieldValues,
  UseFormReturn,
} from 'react-hook-form';

import { Textarea, TextAreaProps } from '@nextui-org/react';

import {
  FormControl,
  FormField,
  FormItem,
  useFormField,
} from '@/components/ui/form';

interface Props extends TextAreaProps {
  formReactHookForm: UseFormReturn<any>;
  name: string;
}
export const FormTextArea = ({ formReactHookForm, ...props }: Props) => {
  return (
    <FormField
      control={formReactHookForm.control}
      name={props.name}
      // @ts-ignore
      render={({ field }) => <FormItemTextArea {...field} {...props} />}
    />
  );
};

const FormItemTextArea = ({
  ...props
}: Omit<Props, 'formReactHookForm'> &
  ControllerRenderProps<FieldValues, string>) => {
  const { error } = useFormField();

  return (
    <FormItem>
      <FormControl>
        <Textarea
          {...props}
          errorMessage={error?.message}
          isInvalid={!!error?.message}
          color={error?.message ? 'danger' : 'default'}
        />
      </FormControl>
    </FormItem>
  );
};
